import React, { Component } from 'react'
import { when } from 'mobx'

const Loaded = Symbol('loaded')
const Mounted = Symbol('mounted')

export default class LoadingComponent extends Component {

  hasLoaded() {
    throw new Error('You must override hasLoaded')
  }

  constructor(...args) {
    super(...args)
    this[Loaded] = false
    this[Mounted] = false
    this.loadedWatcher = when(this.hasLoaded.bind(this), () => {
      this[Loaded] = true
      this.componentDidLoad()
      if (this[Mounted]) this.forceUpdate()
    })
  }

  componentDidMount() {
    this[Mounted] = true
  }

  componentWillUnmount() {
    this.loadedWatcher()
  }

  componentDidLoad() {}

  renderLoading() {
    return (
      <div className="loading">Loading...</div>
    )
  }

  renderLoaded() {
    throw new Error('You must override renderLoaded')
  }

  render() {
    return this[Loaded] ? this.renderLoaded() : this.renderLoading()
  }
}



// WEBPACK FOOTER //
// client/components/LoadingComponent.js